import { Navigate, Outlet, useNavigation } from "react-router-dom";
import { usePermissions } from ".";
import { LoaderFallback } from "@genai/fallback";
import { KnownPermission } from "../model";

export const AdminGuard = () => {
  const navigation = useNavigation();

  const { allowed: isAdmin, loading } = usePermissions([
    KnownPermission.ADMIN,
    KnownPermission.SUPERADMIN,
  ]);

  return loading ? (
    <LoaderFallback />
  ) : isAdmin ? (
    navigation.state === "loading" ? (
      <LoaderFallback />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/" replace />
  );
};
